import classnames from 'classnames';
import React from 'react';

import type { LayoutProps } from '../LayoutTypes';
import { getBackgroundColorClassName, getGridSeperatorSizeClassName } from '../getLayoutClassnames';
import LayoutItems from './LayoutItems';

const LayoutContainer: React.FC<LayoutProps> = ({
    layoutClassNames,
    itemClassNames,
    backgroundColor,
    children,
    gridSeperatorSize,
    whiteSpaceNone = false,
}) => (
    <div
        className={classnames(
            'sgw-layout',
            layoutClassNames,
            getBackgroundColorClassName(backgroundColor),
            getGridSeperatorSizeClassName(gridSeperatorSize),
            { 'sgw-layout-white-space-none': whiteSpaceNone },
        )}
    >
        <LayoutItems itemClassNames={itemClassNames}>{children}</LayoutItems>
    </div>
);

export default LayoutContainer;
